import { useContext, useMemo } from 'react';
import { AnalyticsProvider } from './analytics-provider';

export const useAnalytics = () => {
  const context = useContext(AnalyticsProvider.AnalyticsContext);

  if (!context) {
    throw new Error('useAnalytics must be used within AnalyticsProvider');
  }
  return useMemo(() => context.analytics, [context.analytics]);
};
